module.exports = __webpack_public_path__ + "img/dianchi-100.754a96d2.png";